











import {Component, Vue, Prop, Watch} from "vue-property-decorator";
import '../lib/3rd/jquery.media/jquery.min';
import '../lib/3rd/jquery.media/jquery.media';
import AppConsts, {EMPTY_OBJECT} from "@/lib/appconst";

@Component({name: 'pdfPreview'})
export default class pdfPreview extends Vue {
    @Prop({type: String, default: 'pdfPreview'}) id: string;
    @Prop({type: String, default: ''}) url: string;
    @Prop({type: Object, default: EMPTY_OBJECT}) options: object;

    //默认配置项
    defOptions: object = {
        width: "100%",
        height: "800",
        autoplay: true
    };

    get getUrl() {
        return `${AppConsts.fileResourceUrl}${this.url}`;
    }

    init(id: string) {
        if (id) {
            let dom: any = $(`#${id}`);
            dom.media(this.defOptions);
        }
    }

    created() {
        this.$nextTick(() => {
            this.init(this.id);
        });
    }

    @Watch('id')
    handleChangeId(newVal: string, oldVal: string) {
        if (newVal !== oldVal) {
            this.init(this.id);
        }
    }

    @Watch('options')
    handleChangeOptions(newVal: object, oldVal: object) {
        if (newVal !== oldVal) {
            this.defOptions = Object.assign(this.defOptions, newVal);
        }
    }
}
